import { Injectable } from '@angular/core';
import hljs from 'highlight.js';
import { Marked } from "marked";
import { markedHighlight } from "marked-highlight";

@Injectable({
    providedIn: 'root',
})
export class MarkdownService {

    marked: Marked;

    constructor() {
        this.configureMarked();
    }

    // 配置 marked，支持代码高亮
    private configureMarked(): void {
        this.marked = new Marked(
            markedHighlight({
                langPrefix: 'hljs language-',
                highlight(code, lang, info) {
                    const language = hljs.getLanguage(lang) ? lang : 'plaintext';
                    return hljs.highlight(code, { language }).value;
                }
            })
        );

        this.marked.setOptions({
            highlight: (code, language) => {
                const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
                return hljs.highlight(validLanguage, code).value;
            },
            langPrefix: 'hljs language-', // 代码高亮的类前缀
        } as any);
    }

    // 将Markdown字符串解析为HTML
    parse(markdown: string) {
        try {
            return this.marked.parse(markdown);
        } catch (error) {
            console.warn('Error parsing markdown: ', error);
            return markdown;
        }
    }
}
